import defaultPrices from "src/prices";

export interface PriceItem {
  name: string;
  label: string;
  unit: string;
  price: number;
}

let cachedPrices: PriceItem[] | null = null;

export async function loadPrices(): Promise<PriceItem[]> {
  // Return cached prices if already loaded
  if (cachedPrices) {
    return cachedPrices;
  }

  try {
    // Try to fetch configurable prices from public folder
    const response = await fetch("/prices.json");

    if (response.ok) {
      const publicPrices: PriceItem[] = await response.json();
      console.log("Loaded configurable prices from public/prices.json");
      cachedPrices = publicPrices;
      return cachedPrices;
    }
  } catch (error) {
    console.warn(
      "Failed to load configurable prices, falling back to default:",
      error
    );
  }

  // Fallback to default prices from src/prices
  console.log("Using default prices from src/prices");
  cachedPrices = defaultPrices;
  return cachedPrices;
}

export function clearPriceCache(): void {
  cachedPrices = null;
}

// Synchronous fallback for backward compatibility
export function getPricesSync(): PriceItem[] {
  if (cachedPrices) {
    return cachedPrices;
  }

  // If prices haven't been loaded yet, return default prices
  console.warn("Prices not loaded asynchronously, using default prices");
  return defaultPrices;
}
